import React, { useEffect, useContext } from 'react';

// import './NavBarButton.css'

import RulesMenuCampaign from './Rules/RulesMenuCampaign.jsx';
import RulesMenuClass from './Rules/RulesMenuClass.jsx';
import RulesMenuCombat from './Rules/RulesMenuCombat.jsx';
import RulesMenuItems from './Rules/RulesMenuItems.jsx';
import RulesMenuSkills from './Rules/RulesMenuSkills.jsx';
import RulesMenuPDF from './Rules/RulesMenuPDF.jsx';


import Dropdown from '../common/Dropdown'

import { UserDataContext } from "../../App.js";
import { DEFAULT_CAMPAIGN } from '../../globals.js';


// ----------------------------------------------------------------------------------
//                         Description
//
//     Rulesbutton provides a button and drop-down menu for accessing Rules
//  
//     div == .navbaritem
//       button == #nav-menu-rules .nav-menu-button
//         menu items == .menu .rules-menu > ul
//
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------

function RulesButton(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------

    // let [currentChar, setChar] = props.state;
    const [userData, setUserData] = useContext(UserDataContext);

    const setRule = props.setRule;

    // -------- local state variables --------

    // ------------- useEffect ---------------

    useEffect( () => {

        async function DoSomething () {   
        }

        DoSomething();

    }, [ userData ]); //useEffect

    // ---------- return html (jsx) ----------

    const restricted_rules = userData.loggedIn ? { /* space3: ['---'],books: ['Players Handbook'] */ }: {}

    const restricted_Greyhawk20 = (userData?.dynamoData?.campaigns ?
    ( Object.keys(userData.dynamoData.campaigns).includes(DEFAULT_CAMPAIGN) ? ['PDFs'] : [] ) :
        [] )
    
    console.log(restricted_Greyhawk20)
    const rule_source = {
        tables: ['Combat', 'Saving Throws', 'Skills', 'Class'],
        // space1: ['---'],
        campaign: ['Campaign'],
        // spells: ['Spells-Cleric', 'Spells-MagicUser', 'Spells-Druid', 'Spells-Illusionist'],
        // space2: ['---'],
        items: [ 'Items' ],
        // space3: ['---'],
        magicItems: [  ...restricted_Greyhawk20 ],
        space4: restricted_rules.space3 || [],
        books: restricted_rules.books || []
      };
      
    
    let rules = [];
    let rules_dir = [];
    for (var source in rule_source) {
        let rule_list = rule_source[source];
        for (const rule of rule_list) {
            rules.push(rule);
            rules_dir.push(source);
        }
    }

    const handleMenu = (selection) => {

        let Img;
        let imgSet = false;

        // TABLES

        if ( rules[selection] === 'Skills' ) {
            // handle this in the return jsx
        }

        if ( rules[selection] === 'Class' ) {
            // handle this in the return jsx
        }
       
       // CAMPAIGN RULES
        if ( rules[selection] === 'Campaign' ) {
            // handle this in the return jsx
        }



        // ITEMS
        if ( rules[selection] === 'Saving Throws' ) {
            Img = require(`../../pdf/SavingThrows.jpg`)
            imgSet = true;
        }

        if ( rules[selection] === 'Armor' ) {
            Img = require(`../../pdf/items/Armor.jpg`)
            imgSet = true;
        }

        if ( rules[selection] === 'Weapons' ) {
            Img = require(`../../pdf/items/Weapons.jpg`)
            imgSet = true;
        }


        // DISPLAY IMAGE IN WINDOW (if set)
        if ( imgSet ) {
            if ( props.setRule ) {
                setRule( { title: rules[selection], source: Img })
            }

            document.getElementById('rulesWindow').style.display = 'block';
            // document.getElementsByClassName('rules-menu')[0].style.display = 'none';
            return;
        }


    // For all other entries, attempt to display a pdf with the same name
    if ( rules[selection] !== '---')  {
    
        var URL = rules_dir[selection] + '/' + rules[selection] + '.pdf';
    
        var Pdf = require(`../../pdf/${URL}`)

        window.open(Pdf, '_blank').focus();
    }
    }
    

    return (
        <>
        <Dropdown
            divClass='navbaritem'
            trigger = {<button id="nav-menu-rules" className="nav-menu-button">Rules</button>}
            menu = { rules.map ( ( rule, idx) => { 
            
                if ( rule === 'Combat' ) {
                    return <RulesMenuCombat key={idx} {...props} /> 
                }
                if ( rule === 'Class' ) {
                    return <RulesMenuClass key={idx} {...props} /> 
                }
                if ( rule === 'Skills' ) {
                    return <RulesMenuSkills key={idx} {...props} /> 
                }
                if ( rule === 'Campaign' ) {
                    return <RulesMenuCampaign key={idx} {...props} /> 
                }
                if ( rule === 'Items' ) {
                    return <RulesMenuItems key={idx} {...props} /> 
                }
                if ( rule === 'PDFs' ) {
                    return <RulesMenuPDF key={idx} {...props} /> 
                }

                return <button id={'rules-but-' + idx } onClick={()=>handleMenu(idx)}>{rule}</button>
            }
            )}
            
            menuClass='menu rules-menu'
        />
        </>
    )

    };  // end of function

    export default RulesButton